// @mui
import Container from '@mui/material/Container';
// hooks
// _mock
// components
import { useSettingsContext } from 'src/components/settings';
import EquipmentsTable from './equipments-table';
// assets
//

// ----------------------------------------------------------------------

export default function TechnicalEquipments() {
    // const { user } = useMockedUser();
    const settings = useSettingsContext();
    return (
        <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
            <EquipmentsTable />
        </Container >
    );
}
